
<template>
  <div class="page" id="page">
    <div class="page_top_bg">
      <img
        src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937261383/culture_top_bg.png"
      />
    </div>
    <div class="page_wrap">
      <div class="culture_tips">
        公司始终坚持以“精诚合作,开拓创新”的企业精神,倡导“天道酬勤、厚德载物”的企业价值观,秉承“诚信为本.重诺守信”的服务宗旨,不懈追求“更高、更新、更精”,
        推进科学化、精细化管理,开拓进取、追求卓越、创先争优,诚信为本、“诚于心,信干行”打造“中致远”优秀全过程工程技术服务企业品牌。
      </div>
      <div class="culture_img">
        <div class="img_item">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937284082/img1.png"
            alt=""
          />
        </div>
        <div class="img_item">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937284106/img2.png"
            alt=""
          />
        </div>
        <div class="img_item">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937284219/img3.png"
            alt=""
          />
        </div>
        <div class="img_item">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937284292/img4.png"
            alt=""
          />
        </div>
      </div>
      <div class="wrap_white">
        <div class="wrap_title">
          <span>公司</span>
          <span>环境</span>
        </div>
        <div class="wrap_translate">Company Environment</div>
        <div class="wrap_flex">
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937363605/b_img1.png"
              alt=""
            />
          </div>
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937363733/b_img2.png"
              alt=""
            />
          </div>
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937363773/b_img3.png"
              alt=""
            />
          </div>
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937363938/b_img4.png"
              alt=""
            />
          </div>
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937364084/b_img5.png"
              alt=""
            />
          </div>
          <div class="flex_img">
            <img
              src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937364117/b_img6.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="wrap_white" id="framework">
        <div class="wrap_title">
          <span>组织架构</span>
        </div>
        <div class="wrap_translate">Organizational Structure</div>
        <div class="wrap_jiagou">
          <img
            src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741937438371/jiagou.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { watchEffect } from "vue";
import { useRoute } from "vue-router";
import { scrollToAnchor } from "@/utils/scrollToAnchor";
import {
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance() as any;
    const route = useRoute();
    const state = reactive({});
    onMounted(() => {});
    watchEffect(() => {
      if (route.query.anchor) {
        scrollToAnchor(route);
      }
    });
    return {
      ...toRefs(state),
    };
  },
});
</script>
<style scoped lang="scss">
.page {
  padding-bottom: 64px;
  .page_top_bg {
    width: 100%;
    height: 426px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 426px;
      object-fit: cover;
    }
  }
  .page_wrap {
    width: 1600px;
    margin: 0px auto 0px;
    position: relative;
    z-index: 10;
    .culture_tips {
      width: 1119px;
      margin: 0 auto;
      text-align: center;
      font-size: 16px;
      color: #000000;
      padding: 60px 0px 40px;
    }
    .culture_img {
      display: flex;
      justify-content: space-between;
      .img_item {
        img {
          display: block;
        }
      }
    }
    .wrap_white {
      margin-top: 60px;
      background: #ffffff;
      padding: 64px 40px 40px;
      .wrap_title {
        text-align: center;
        span:nth-of-type(1) {
          font-weight: 600;
          font-size: 40px;
          color: #000000;
        }
        span:nth-of-type(2) {
          font-weight: 600;
          font-size: 40px;
          color: #317ed2;
        }
      }
      .wrap_translate {
        text-align: center;
        padding-top: 2px;
        font-size: 24px;
        color: #a9a9a9;
      }
      .wrap_flex {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        padding-top: 10px;
        .flex_img {
          margin-top: 24px;
          img {
            display: block;
          }
        }
      }
      .wrap_jiagou {
        display: flex;
        justify-content: center;
        padding-top: 53px;
        img {
          display: block;
        }
      }
    }
  }
}
</style>
  